'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _find = require('lodash-compat/collection/find');

var _find2 = _interopRequireDefault(_find);

var _createChainedFunction = require('../utils/createChainedFunction');

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _ValidComponentChildren = require('../utils/ValidComponentChildren');

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

var _safeAttributes = require('../utils/safeAttributes');

var _safeAttributes2 = _interopRequireDefault(_safeAttributes);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TreeNavNodes = function (_React$Component) {
  _inherits(TreeNavNodes, _React$Component);

  function TreeNavNodes(props) {
    _classCallCheck(this, TreeNavNodes);

    var _this = _possibleConstructorReturn(this, (TreeNavNodes.__proto__ || Object.getPrototypeOf(TreeNavNodes)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.extractChildren = _this.extractChildren.bind(_this);
    _this.refineMenuItem = _this.refineMenuItem.bind(_this);
    _this.childExtractors = [{
      key: 'menuItem',
      matches: function matches(child) {
        return child.props.role === 'menuItem';
      },
      refine: _this.refineMenuItem
    }];
    return _this;
  }

  _createClass(TreeNavNodes, [{
    key: 'handleClick',
    value: function handleClick(keyIndex) {
      if (this.props.handleClick) {
        this.props.handleClick(keyIndex);
      }
    }
  }, {
    key: 'extractChildren',
    value: function extractChildren() {
      var _this2 = this;

      var seen = {};
      this.incrementer = 0;
      return _ValidComponentChildren2.default.map(this.props.children, function (child) {
        var extractor = (0, _find2.default)(_this2.childExtractors, function (x) {
          return x.matches(child);
        });

        if (extractor) {
          if (seen[extractor.key]) {
            return false;
          }

          seen[extractor.key] = extractor.exclusive;
          return extractor.refine(child);
        }

        return child;
      });
    }
  }, {
    key: 'refineMenuItem',
    value: function refineMenuItem(menu) {
      var _this3 = this;

      var ref = function ref(r) {
        return _this3.menu = r;
      };

      if (typeof menu.ref === 'string') {
        (0, _warning2.default)(false, 'String refs are not supported on `TreeNodes` components. ' + 'To apply a ref to the component use the callback signature: \n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
      } else {
        ref = (0, _createChainedFunction2.default)(menu.ref, ref);
      }

      this.incrementer = this.incrementer + 1;
      var menuProps = {};
      menuProps = {
        ref: ref,
        keyIndex: this.props.keyIndex + '-' + this.incrementer,
        selectedIndex: this.props.selectedIndex
      };

      menuProps.handleClick = this.handleClick;

      return (0, _react.cloneElement)(menu, menuProps, menu.props.children);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.extractChildren();
      var props = (0, _safeAttributes2.default)(this.props);
      return _react2.default.createElement(
        'ul',
        props,
        children
      );
    }
  }]);

  return TreeNavNodes;
}(_react2.default.Component);

TreeNavNodes.propTypes = {
  selectedIndex: _propTypes2.default.any,
  handleClick: _propTypes2.default.func,
  keyIndex: _propTypes2.default.any
};

TreeNavNodes.defaultProps = {};

exports.default = TreeNavNodes;